'use client'

import { createContext, useContext, type ReactNode } from 'react'

export type SectionVariation = Record<string, unknown> | null | undefined

const SectionContext = createContext<SectionVariation>(null)

/**
 * Per-section experiment context (parity with pages-router ChildComponentGenerator).
 * Variation is built on the server and passed through SectionProviderServer.
 */
export function SectionProvider({
  children,
  variation = null,
}: {
  children: ReactNode
  variation?: SectionVariation
}) {
  return <SectionContext.Provider value={variation}>{children}</SectionContext.Provider>
}

export function useSectionVariation() {
  return useContext(SectionContext)
}

export { SectionContext }
